import React from "react";
import SEO from "../../../components/SEO";
import { Mail, Award } from "lucide-react";
import AmanImg from "../../../assets/Aman.jpg";
import { Link } from "react-router-dom";
import Testimonials from "../../../components/Testimonials";




const Aman = () => {

  const facts = [
    {
      title: "Éducation",
      backText:
        "Aman a grandi dans la ville de Chandigarh, en Inde, où il a obtenu un baccalauréat en génie informatique et technologie de l'information. Aman s'est inscrit à l'Université d'Ottawa, où il a complété sa maîtrise en technologies d'affaires électroniques.",
    },
    {
      title: "Carrière",
      backText:
        "Après avoir terminé ses études postsecondaires, Aman a débuté sa carrière dans la courtage d'assurances de son oncle, axée sur la protection des Canadiens, en particulier au sein de la communauté sud-asiatique. Cette expérience précoce l'a inspiré à poursuivre une carrière dans les services financiers. Après six ans en tant que conseiller en sécurité financière, il a finalement fondé sa propre courtage, einsured.ca, en 2018.",
    },
    {
      title: "Médias",
      backText:
        "Ces dernières années, Aman a été présenté à la fois sur les médias sociaux et dans des émissions radiophoniques pour aider à éduquer le public sur les différents produits d'assurance. Il est également activement impliqué dans la communauté locale, sensibilisant aux nouvelles petites entreprises.",
    },
    {
      title: "Reconnaissance",
      icon: <Award size={36} />,
      backText:
        "Aman a été reconnu comme membre du Million Dollar Round Table (MDRT), la première association de professionnels financiers®, en 2024. Les membres du MDRT font preuve d'une connaissance professionnelle exceptionnelle, d'une conduite éthique rigoureuse et d'un service client remarquable. L'adhésion au MDRT est reconnue internationalement comme la norme d'excellence dans le domaine de l'assurance vie et des services financiers.",
    },
  ];

  return (
    <>
      <SEO
        title="Aman – Fondateur et PDG  – einsured.ca"
        description="Découvrez Aman, fondateur et PDG d'einsured.ca, qui dirige son équipe pour offrir des solutions d’assurance fiables au Canada."
        keywords="Aman Ahuja, PDG einsured.ca, membre MDRT 2024, meilleur courtier d'assurances Canada, expert en assurances de Chandigarh au Canada"
        ogType="profile"
      />

      <section
        className="min-h-screen flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 py-16"
        style={{ backgroundColor: "#f5f9ff" }}
      >
        <style>{`
          .flip-card {
            background-color: transparent;
            perspective: 1000px;
          }
          .flip-card-inner {
            position: relative;
            width: 100%;
            height: 260px;
            text-align: center;
            transition: transform 0.8s;
            transform-style: preserve-3d;
            border-radius: 24px;
            box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
          }
          .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
          }
          .flip-card-front,
          .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 24px;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
             font-family: "Montserrat", sans-serif;
            font-weight: 600;
          }
          .flip-card-front {
            background: linear-gradient(to bottom, #12a5dd, #3b4f80);
            color: white;
          }
          .flip-card-back {
            background: linear-gradient(to bottom, #3b4f80, #12a5dd);
            transform: rotateY(180deg);
            color: white;
            padding: 0 1.5rem;
          }
           @media (max-width: 640px) {

    .flip-card-inner {
      height: auto;
      transform: none !important;
    }


    .flip-card:hover .flip-card-inner {
      transform: none;
    }


    .flip-card-front {
      display: none;
    }

    .flip-card-back {
      position: relative;
      transform: none;
      padding: 1.5rem;
    }
  }
        `}</style>

        {/* TOP SECTION */}
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-start">
          {/* LEFT SIDE */}
          <div className="flex flex-col items-center md:items-start w-full">
            {/* Blue Box */}
            <div
              className="w-full rounded-t-[32px] px-8 py-6 text-center md:text-left shadow-md"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <h1 className="text-4xl font-bold mb-2">Aman Ahuja</h1>
              <p className="text-lg font-semibold">Fondateur &amp; PDG</p>
            </div>
            <div
              className="w-full rounded-b-[32px] px-8 py-8 shadow-lg"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <p className="text-base leading-relaxed mb-10 text-center md:text-left">
                Le dévouement d'Aman et son approche innovante en assurance
                personnelle, ainsi que son équipe chez einsured.ca, garantissent
                un service de premier ordre à ses clients. Aman est devenu
                membre du MDRT en 2024, reconnu pour ses connaissances
                exceptionnelles, son éthique et son service client. Ses efforts
                en ont fait l'un des meilleurs courtiers d'assurances du pays.
              </p>

              {/* CONTACT */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
                <a
                  href="tel:+14168166100"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md text-center"
                >
                  (416) 816-6100
                </a>

                <a
                  href="mailto:aman@einsured.ca"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md flex items-center justify-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  aman@einsured.ca
                </a>

                <a
                  href="tel:+14168400128"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md text-center"
                >
                  (416) 840-0128 ext. 100
                </a>
              </div>
            </div>

            {/* BOOK A MEETING */}
            <div className="text-center md:text-left mt-10 md:mt-12">
              <a
                href="https://book.einsured.ca/widget/bookings/ei-team"
                className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition"
              >
                Prendre un rendez-vous
              </a>

              <p className="text-sm mt-6">Consultations gratuites de 15 à 30 minutes.</p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end">
            <img
              src={AmanImg}
              alt="Aman Ahuja"
              className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top"
            />
          </div>
        </div>

        {/*  FACTS */}
        <div className="mt-24 max-w-6xl w-full">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-4">
              Quelques faits sur Aman Ahuja
            </h2>
            <p className=" text-base sm:text-lg">
              Explorez le profil d'Aman pour mieux comprendre ses domaines
              d'expertise et ses intérêts personnels.
            </p>
          </div>

          {/* Flip Cards Grid */}
          <div className="grid sm:grid-cols-2 gap-10 max-w-5xl mx-auto">
            {facts.map((fact) => (
              <div key={fact.title} className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front">
                    {fact.icon && (
                      <div className="mb-3 flex justify-center">
                        {fact.icon}
                      </div>
                    )}
                    <h3 className="text-white text-2xl font-bold">
                      {fact.title}
                    </h3>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-back">
                    <p className="text-white text-base leading-relaxed font-normal">
                      {fact.backText}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4 EASY STEPS */}
      <section className="w-full flex justify-center bg-white py-24 px-6 sm:px-12 md:px-24">
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-16 items-center">
          {/* LEFT SIDE TEXT */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-5">
              4 étapes simples
            </h2>
            <p className="text-base sm:text-lg text-[#5f6f8f] mb-10 max-w-lg">
              Obtenez votre protection en quelques minutes et profitez d'une
              couverture d'assurance vie parfaitement adaptée à vos besoins.
            </p>

            <Link
              to="/fr/prendre-rendez-vous"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-12 py-3.5 rounded-full shadow-lg transition"
            >
              Prendre un rendez-vous
            </Link>
            <p className="text-sm mt-4">Consultations gratuites de 15 à 30 minutes.</p>
          </div>

          {/* RIGHT SIDE */}
          <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-10 py-10 md:px-14 md:py-12">
            <div className="relative pl-4">
              <div className="absolute left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>

              {/* Step 1 */}
              <div className="flex items-start gap-6 mb-10 relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-xl shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-lg mb-1">
                    Informations de base
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions de base pour nous aider à
                    mieux vous connaître.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-6 mb-10 relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-xl shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-lg mb-1">
                    Analyse des besoins
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed font-normal">
                    Déterminez la couverture appropriée pour protéger vos
                    proches.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-6 mb-10 relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-xl shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-lg mb-1">
                    Questions de santé
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions liées à la santé pour obtenir
                    un produit adapté à vos besoins.
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-6 relative z-10">
                <div className="w-12 h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-xl shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-lg mb-1">
                    Obtenez votre soumission gratuite !
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Testimonials limit={9} autoPlay={true} intervalMs={4500} />
    </>
  );
};

export default Aman;
